import React from 'react'
import SmsForm from '../Login/SmsForm/index.jsx'

export default function VisitorCheckout(props) {
  return <SmsForm visitor={true} {...props}></SmsForm>
}
